<template>
  <div>
    <template v-if="isShowCart">
      <div class="cart-boxs-bg" @click="isShowCart = false"></div>
      <div class="cart-boxs">
        <div class="top"><span>清单列表</span><div class="close" @click="isShowCart = false">×</div></div>

        <div>
          <div class="cart-boxs-left">
            <h3 class="cart-left-title"><span>店铺积分</span></h3>
            <div class="c-logo">
              <img :src="shopInfo.topPicture" />
            </div>
            <div class="c-buy-r">
              <h3>{{shopInfo.merchantName}}</h3>
              <div class="c-buy-label fix"><span>可用积分 </span><IconJifen size="mini" :points="shopInfo.points" /></div>
              <router-link class="c-buy-m" :to="`/my/jifen/${shopInfo.merchantCode}`">积分明细 >></router-link>
            </div>
          </div>

          <div class="cart-boxs-right">
            <h3 class="cart-left-title"><span>礼品清单</span><div class="c-x" @click="allDelMsg"><i class="icons del-crat"></i>清空全部</div></h3>
            <div class="cart-list-scroll fix">
              <template v-for="(n) in carts.cartDetails">
                <FootCartItem v-if="n.status != 20 && n.auditStatus == 2 && n.stock > 0" :merchantCode="carts.merchantCode" :key="n.id" :item="n"/>
              </template>
              <NoList v-if="carts.cartDetails.length == 0" title="清单列表还没有礼品" />

              <template v-if="noSubmit > 0">
                <h3 class="cart-left-title title-invalid"><span>失效礼品</span><div class="c-x" @click="allDelNoMsg"><i class="icons del-crat"></i>清空失效礼品</div></h3>
                <template v-for="(n,idx) in carts.cartDetails">
                  <FootCartItem v-if="n.status == 20 || n.auditStatus != 2 || n.stock == 0" :merchantCode="carts.merchantCode" :key="idx" :item="n"/>
                </template>
              </template>
            </div>
          </div>
        </div>
      </div>
    </template>

    <div :style="{ left: offset.x + 'px', bottom: offset.y + 'px' }" v-if="loadingDh" class="to-carts-icon"></div>

    <div class="cart-foot">
      <div class="cart-bottom">
        <div class="cart-text">
          
          <img  v-if="!loadingDh" class="icon-cart" src="../assets/icon-cart.png">
          <img v-else class="icon-cart" src="../assets/icon-cart-open.png">
          <div class="c-title">
            <IconJifen :points="totalAmount" />
            <p>共 <span class="c-color">{{ totalQuantity || 0 }}</span> 件礼品<a @click="isShowCart = !isShowCart" class="c-href">{{ isShowCart ? '收起' : '展开'}}清单列表 >></a></p>
          </div>
          <!-- <router-link v-if="totalAmount > 0" tag="button" class="cart-btn" :to="`/checkout/${shopInfo.merchantCode}`">结算</router-link> -->
          <button v-if="totalAmount > 0" @click="isSubmit" class="cart-btn">结算</button>
          <button v-else class="cart-btn disabled-submit">结算</button>
        </div>
      </div>
    </div>

    <confirm :titleTig="titleTig == 'del' ? '清空礼品清单' : titleTig == 'no' ? '清空失效礼品' : '结算失败'" :closeText="closeText" :message='message' @confirmok="confirmok" :shows="show"></confirm>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import FootCartItem from "./foot-cart-item";
import NoList from "./no-list.vue";
import IconJifen from "./icon-jifen";
import Confirm from "./confirm/main.vue";
export default {
  components: {
    FootCartItem,
    NoList,
    IconJifen,
    Confirm
  },
  computed: {
    ...mapGetters(["offset", "loadingDh", "shopInfo", "carts", "cartList"]),
    totalQuantity() {
      return this.getSum(this.carts.cartDetails);
    },
    totalAmount() {
      return this.getAmount(this.carts.cartDetails);
    },
    noSubmit() {
      return this.submitNo(this.carts.cartDetails);
    }
  },

  watch: {
    isShowCart: function(val) {
      if (val && this.$route.name == "product") {
        document.getElementsByTagName("body")[0].style.overflow = "hidden";
      } else {
        document.getElementsByTagName("body")[0].style.overflow = "auto";
      }
      if (!val) {
        this.$router.replace({ path: window.location.pathname });
      }
    }
  },
  created() {
    const params = this.$storage.getParams(window.location);
    if (params.open) {
      this.isShowCart = true;
    }
  },
  data() {
    return {
      isShowCart: false,
      num: 0,
      titleTig: "",
      message: "",
      closeText:"",
      show: false
    };
  },
  methods: {
    getSum(arr) {
      var s = 0;
      arr &&
        arr.forEach(val => {
          if (val.status != 20 && val.auditStatus == 2 && val.stock > 0) {
            s += val.quantity;
          }
        });
      return s;
    },
    getAmount(arr) {
      var s = 0;
      arr &&
        arr.forEach(val => {
          if (val.status != 20 && val.auditStatus == 2 && val.stock > 0) {
            s += val.quantity * val.price;
          }
        });
      return s;
    },
    submitNo(arr) {
      var s = 0;
      arr &&
        arr.forEach(val => {
          if (val.status == 20 || val.auditStatus != 2 || val.stock == 0) s++;
        });

      return s;
    },
    allDelMsg() {
      this.titleTig = "del";
      this.closeText = "取消"
      this.message = "确认清空礼品清单所有礼品？";
      this.show = true;
    },

    allDelNoMsg() {
      this.titleTig = "no";
      this.closeText = "取消"
      this.message = "确认清空已失效、已下架、暂时缺货的礼品？";
      this.show = true;
    },

    noSubmitMsg() {
      this.titleTig = "noSubmit";
      this.closeText = ""
      this.message =
        "部分礼品兑换数量超出库存或限购数量，请修改兑换数量。（兑换数量为0时，删除该行礼品清单）";
      this.show = true;
    },

    confirmok(k) {
      this.show = false;
      if (k) {
        this.titleTig == "del"
          ? this.allDel()
          : this.titleTig == "no" ? this.allDelNo() : null;
      }
    },

    allDel() {
      this.$store.dispatch("ALLDELCARTS", this.shopInfo.merchantCode);
    },

    allDelNo() {
      var self = this;
      if (this.carts.cartDetails && this.carts.cartDetails.length > 0) {
        let pr = this.carts.cartDetails
          .map(val => {
            if (val.status == 20 || val.auditStatus != 2 || val.stock == 0)
              return val.productCode;
          })
          .filter(v => v != undefined);

        this.$store
          .dispatch("ALLDELNOCARTS", {
            merchantCode: this.shopInfo.merchantCode,
            list: pr
          })
          .then(() => {
            self.$store.dispatch("ALLCARTS", self.shopInfo.merchantCode);
          });
      }
    },

    onSubmit() {
      this.$router.push(`/checkout/${this.shopInfo.merchantCode}`);
    },

    isSubmit() {
      var self = this;

      var s = 0,
        d = self.carts.cartDetails;
      d.length > 0 &&
        d.forEach(val => {
          if (val.status != 20 && val.auditStatus == 2 && val.stock > 0 && (val.quantity > val.stock || val.stock == 0 || val.quantity > val.remainedQuantity || val.remainedQuantity == 0) ) s++;
        });
      if (s > 0) {
        self.noSubmitMsg()
      } else {
        self.onSubmit()
      }
    }
  }
};
</script>
<style>
.c-logo {
  width: 60px;
  height: 60px;
  background-color: #fff;
  border-radius: 6px;
  float: left;
  margin: 10px;
  border: 1px #eee solid;
  overflow: hidden;
}
.c-logo img {
  width: 100%;
  height: 100%;
}
.c-buy-r {
  float: left;
  width: 270px;
  text-align: left;
  margin-top: 20px;
  font-size: 14px;
}
.c-buy-r h3 {
  font-size: 14px;
  line-height: 1.3;
  font-weight: inherit;
  max-height: 38px;
  overflow: hidden;
  color: #333;
}
.c-buy-label {
  margin-top: 6px;
  color: #666;
}

.c-buy-price {
  padding: 0 10px;
  color: #ff7300;
  font-size: 14px;
}
.c-buy-price img {
  width: 20px;
  height: 20px;
  vertical-align: -5px;
  margin-right: 5px;
}
.c-buy-m {
  color: #999;
  margin: 10px 0 0 66px;
  display: block;
}
.to-carts-icon {
  position: fixed;
  background-color: red;
  width: 0;
  height: 0;
  border-radius: 50%;
  border: 8rpx #fff solid;
  opacity: 1;
  z-index: 999;
  animation: to_cart 0.3s ease-out;
}
@keyframes to_cart {
  0% {
    transform: translateX(0);
  }
  30% {
    transform: translateX(-40px);
    width: 20px;
    height: 20px;
  }
  100% {
    bottom: 20px;
    left: 50%;
    margin-left: -520px;
    width: 10px;
    height: 10px;
    opacity: 0;
  }
}
.cart-foot {
  height: 100px;
}
.cart-bottom {
  position: fixed;
  width: 100%;
  min-width: 1200px;
  bottom: 0;
  height: 100px;
  background-color: #333333;
  z-index: 88;
}
.cart-text {
  width: 1200px;
  height: 100px;
  margin: auto;
  position: relative;
  color: #a3a3a3;
}
.cart-text .icon-cart {
  position: absolute;
  top: -60px;
  left: 20px;
  width: 120px;
  height: 120px;
}

.c-title {
  margin: 22px 0 20px 170px;
  line-height: 25px;
  text-align: left;
}
.c-title h1 {
  font-weight: inherit;
  font-size: 18px;
  color: #ffcc00;
}
.c-title h1 img {
  vertical-align: -4px;
  margin-right: 6px;
}
.c-title p {
  font-size: 14px;
}

.c-href {
  margin-left: 10px;
  color: #a3a3a3;
  cursor: pointer;
}
.c-href:hover {
  text-decoration: underline;
}
.cart-btn {
  width: 160px;
  height: 50px;
  position: absolute;
  top: 6px;
  right: 0;
  border-radius: 60px;
  border: none;
  font-size: 20px;
  background: -webkit-linear-gradient(
    to right,
    #ff9d00,
    #ff7300
  ); /* Safari 5.1 - 6.0 */
  background: -o-linear-gradient(
    to right,
    #ff9d00,
    #ff7300
  ); /* Opera 11.1 - 12.0 */
  background: -moz-linear-gradient(
    to right,
    #ff9d00,
    #ff7300
  ); /* Firefox 3.6 - 15 */
  background: linear-gradient(to right, #ff9d00, #ff7300);
  background-color: #ff7300\9\0;
  color: #fff;
  font-weight: inherit;
}
.cart-btn:hover {
  opacity: 0.9;
}
.cart-boxs-bg {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #000;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 65;
}
.cart-boxs {
  width: 1200px;
  height: 600px;
  border: 1px solid #eee;
  position: fixed;
  bottom: 100px;
  background-color: #fff;
  left: 50%;
  margin-left: -605px;
  margin-left: -608px\9;
  z-index: 66;
}
.cart-boxs .top {
  height: 42px;
  background-color: rgb(238, 238, 238);
  width: 100%;
  color: #fff;
  text-align: left;
}
.cart-boxs .top span {
  margin-left: 10px;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  color: #333;
}
.cart-boxs .close {
  position: absolute;
  top: 0;
  right: 0;
  font-size: 28px;
  color: #999;
  width: 40px;
  height: 40px;
  text-align: center;
  cursor: pointer;
  z-index: 6;
  line-height: 40px;
  transition: 1s ease-in-out 0s;
  /* -moz-transition: 1s ease-in-out 0s;
  -webkit-transition: 1s ease-in-out 0s;
  -o-transition: 1s ease-in-out 0s;
  -webkit-backface-visibility: hidden; */
}
.cart-boxs .close:hover {
  -moz-transform: scale(1.1) rotate(360deg);
  -webkit-transform: scale(1) rotate(360deg);
  -webkit-transform-origin: 50% 50%;
  -moz-transform-origin: 50% 50%;
  -moz-transition: 1s ease-in-out 0s;
  -webkit-transition: 1s ease-in-out 0s;
}
.cart-boxs-left {
  width: 360px;
  border-right: 1px solid #eee;
  height: 558px;
  float: left;
}
.cart-boxs-right {
  width: 838px;
  height: 500px;
  float: left;
}
.cart-left-title {
  margin: 0;
  height: 40px;
  line-height: 40px;
  text-align: left;
  border-bottom: 1px solid #eee;
  color: #666;
  font-weight: inherit;
}
.title-invalid {
  border-top: 1px solid #eee;
  margin-top: 12px;
  border-bottom: none;
  height: 30px;
}
.cart-left-title span {
  margin-left: 10px;
}
.c-x {
  float: right;
  margin-right: 10px;
  cursor: pointer;
}
.cart-list-scroll {
  overflow-x: auto;
  height: 505px;
  margin: 0 5px 10px 10px;
}
.c-title .c-color {
  color: #ff0000;
}
.del-crat {
  background-position: -34px -55px;
  display: inline-block;
  width: 14px;
  height: 14px;
  cursor: pointer;
  vertical-align: -2px;
  margin-right: 3px;
}
.disabled-submit {
  color: #bfcbd9;
  cursor: not-allowed;
  background-image: none;
  background-color: #eef1f6;
  border-color: #d1dbe5;
  opacity: 1;
}
</style>
